<template>
  <div class="search-sub-container">
    <transition name="slide">
      <div v-show="isShowSearch" class="search-sub-box">
        <input
            type="text"
            class="search-sub-input"
            v-model="searchQuery"
            placeholder="搜索"
            @keyup.enter="goSearch"
        />
      </div>
    </transition>
  </div>
</template>

<script setup>
import router from "@/router/router.js";
// 使用 defineEmits 定义支持的事件
const emit = defineEmits(['send-search-data'])

const props = defineProps({
  isShowSearchView: Boolean, // 父组件传递的搜索框展开状态
})

const isShowSearch = ref(null)
// 搜索关键词
const searchQuery = ref("")
// 搜索逻辑
const goSearch = () => {
  if (searchQuery.value !== "") {
    isShowSearch.value = false
    emit('send-search-data', false) // 触发事件并传递参数
    router.push({name: 'search', params: {word: searchQuery.value}})
    searchQuery.value = ""
  } else {
    alert("请输入搜索关键词！")
  }
}

onBeforeMount(() => {
  isShowSearch.value = props.isShowSearchView
})

// 监听父组件传递的值
watch(() => props.isShowSearchView, (newValue) => {
  isShowSearch.value = newValue
});

</script>

<style scoped lang="less">
.search-sub-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  overflow: hidden;
}

.search-sub-box {
  display: flex;
  align-items: center;
  width: 295px; /* 默认宽度 */
  height: 30px;
  border: 1px solid #dcdfe6;
  border-radius: 25px;
  background-color: #fff;
  transition: all 0.4s ease; /* 平滑过渡效果 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transform-origin: right center; /* 关键：从右到左动画 */
}

.search-sub-input {
  flex: 1;
  height: 100%;
  padding: 0 15px;
  border: none;
  outline: none;
  font-size: 14px;
  background-color: transparent;

  &::placeholder {
    color: var(--font-color);
    font-style: italic;
  }
}

/* Vue 过渡动画 */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.4s ease;
  transform-origin: right center;
}

.slide-enter-from {
  width: 0;
  opacity: 0;
}

.slide-enter-to {
  width: 295px;
  opacity: 1;
}

.slide-leave-from {
  width: 295px;
  opacity: 1;
}

.slide-leave-to {
  width: 0;
  opacity: 0;
}
</style>


